<template>
  <head>
    <meta charset="utf-8" />
    <title>County Biller - Reconciliation Audit</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
  </head>
  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page header -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">RECONCILIATION AUDIT</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                    <li class="breadcrumb-item"><a @click="gotTo('recon')">Reconciliation</a></li>
                    <li class="breadcrumb-item active">Audit</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Filters -->
          <div class="card">
            <div class="card-header bg-white border-bottom">
              <div class="row g-3 align-items-end">
                <div class="col-md-2">
                  <label class="form-label mb-1">Source:</label>
                  <select class="form-select" v-model="sourceFilter" @change="loadAll">
                    <option value="ALL">All Sources</option>
                    <option value="BANK">Bank (KCB)</option>
                    <option value="MPESA">MPESA</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1">From:</label>
                  <input v-model="dateFrom" class="form-control" type="date">
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1">To:</label>
                  <input v-model="dateTo" class="form-control" type="date">
                </div>
                <div class="col-md-3">
                  <label class="form-label mb-1">Big Amount Threshold (KES):</label>
                  <input v-model.number="threshold" class="form-control" type="number" min="0" step="1000">
                </div>
                <div class="col-md-3">
                  <div class="d-flex gap-2">
                    <button class="btn btn-primary flex-grow-1" @click="loadAll" :disabled="loadingSummary">
                      <i class="bx bx-search me-1"></i> Filter
                    </button>
                    <div class="dropdown">
                      <button class="btn btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown"
                              :disabled="loadingSummary || (totals.totalRecords || 0) === 0">
                        <i class="bx bxs-download"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <li><h6 class="dropdown-header">Full Report (All Sections)</h6></li>
                        <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportFullReportPDF"><i class="bx bxs-file-pdf me-2 text-danger"></i>Full Report PDF</a></li>
                        <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportFullReportCSV"><i class="bx bxs-file me-2 text-primary"></i>Full Report CSV</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Stats Bar -->
            <div class="card-header bg-light border-bottom py-2">
              <div class="row text-center">
                <div class="col-md-3">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="bx bx-upload text-primary fs-4 me-2"></i>
                    <div class="text-start">
                      <small class="text-muted d-block">Total Uploaded</small>
                      <strong class="fs-5 text-primary">KES {{ formatPrice(totals.totalUploaded || 0) }}</strong>
                      <small class="text-muted d-block">{{ numberFormat(totals.totalRecords || 0) }} records</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" @click="setDetailFilter('receipted')" style="cursor:pointer">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="bx bx-check-circle text-success fs-4 me-2"></i>
                    <div class="text-start">
                      <small class="text-muted d-block">Receipted (Has Invoice)</small>
                      <strong class="fs-5 text-success">KES {{ formatPrice(totals.totalReceipted || 0) }}</strong>
                      <small class="text-muted d-block">{{ numberFormat(totals.receiptedCount || 0) }} records</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" @click="setDetailFilter('unallocated')" style="cursor:pointer">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="bx bx-time-five text-warning fs-4 me-2"></i>
                    <div class="text-start">
                      <small class="text-muted d-block">Unallocated (No Invoice)</small>
                      <strong class="fs-5 text-warning">KES {{ formatPrice(totals.totalUnallocated || 0) }}</strong>
                      <small class="text-muted d-block">{{ numberFormat(totals.unallocatedCount || 0) }} records</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" @click="setDetailFilter('missing')" style="cursor:pointer">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="bx bx-error text-danger fs-4 me-2"></i>
                    <div class="text-start">
                      <small class="text-muted d-block">Not Used</small>
                      <strong class="fs-5 text-danger">KES {{ formatPrice(totals.totalMissing || 0) }}</strong>
                      <small class="text-muted d-block">{{ numberFormat(totals.missingCount || 0) }} records</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Monthly Breakdown -->
          <div class="card">
            <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
              <h4 class="card-title mb-0">Monthly Breakdown</h4>
              <div class="d-flex gap-2">
                <div class="dropdown" v-if="monthlySummary.length > 0">
                  <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    <i class="bx bxs-download me-1"></i> Export
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportMonthlyToPDF"><i class="bx bxs-file-pdf me-2 text-danger"></i>PDF</a></li>
                    <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportMonthlyToCSV"><i class="bx bxs-file me-2 text-primary"></i>CSV</a></li>
                  </ul>
                </div>
                <button class="btn btn-sm btn-outline-secondary" @click="showMonthly = !showMonthly">
                  <i :class="showMonthly ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
                </button>
              </div>
            </div>
            <div class="card-body p-0" v-show="showMonthly">
              <div v-if="loadingSummary" class="text-center py-4">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                <span class="ms-2 text-muted">Loading summary...</span>
              </div>
              <div class="table-responsive" v-else-if="monthlySummary.length > 0">
                <table class="table table-hover mb-0">
                  <thead class="table-dark">
                  <tr>
                    <th>Month</th>
                    <th class="text-end">Total Uploaded</th>
                    <th class="text-end">Receipted</th>
                    <th class="text-end">Unallocated</th>
                    <th class="text-end">Not Used</th>
                    <th class="text-center">Records (R/U/M)</th>
                    <th class="text-center">Receipted %</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in monthlySummary" :key="row.month">
                    <td class="fw-medium">{{ formatMonth(row.month) }}</td>
                    <td class="text-end">KES {{ formatPrice(row.totalUploaded) }}</td>
                    <td class="text-end text-success">KES {{ formatPrice(row.totalReceipted) }}</td>
                    <td class="text-end text-warning">KES {{ formatPrice(row.totalUnallocated) }}</td>
                    <td class="text-end text-danger">KES {{ formatPrice(row.totalMissing) }}</td>
                    <td class="text-center">
                      <span class="badge bg-success">{{ row.receiptedCount }}</span>
                      /
                      <span class="badge bg-warning text-dark">{{ row.unallocatedCount }}</span>
                      /
                      <span class="badge bg-danger">{{ row.missingCount }}</span>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center justify-content-center gap-2">
                        <div class="progress flex-grow-1" style="height: 6px; max-width: 80px">
                          <div class="progress-bar bg-success" :style="{ width: getMonthReceiptedPct(row) + '%' }"></div>
                        </div>
                        <small>{{ getMonthReceiptedPct(row) }}%</small>
                      </div>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-outline-primary" @click="drillIntoMonth(row.month)">
                        <i class="bx bx-right-arrow-alt"></i>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-center py-4 text-muted">No data for selected period</div>
            </div>
          </div>

          <!-- Upload History -->
          <div class="card">
            <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
              <h4 class="card-title mb-0">Upload History</h4>
              <div class="d-flex gap-2">
                <div class="dropdown" v-if="uploads.length > 0">
                  <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    <i class="bx bxs-download me-1"></i> Export
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportUploadsToPDF"><i class="bx bxs-file-pdf me-2 text-danger"></i>PDF</a></li>
                    <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportUploadsToCSV"><i class="bx bxs-file me-2 text-primary"></i>CSV</a></li>
                  </ul>
                </div>
                <button class="btn btn-sm btn-outline-secondary" @click="showUploads = !showUploads">
                  <i :class="showUploads ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
                </button>
              </div>
            </div>
            <div class="card-body p-0" v-show="showUploads">
              <div v-if="loadingUploads" class="text-center py-4">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
              </div>
              <div class="table-responsive" v-else-if="uploads.length > 0">
                <table class="table table-hover mb-0">
                  <thead class="table-dark">
                  <tr>
                    <th>Date</th>
                    <th>Uploaded By</th>
                    <th>Type</th>
                    <th class="text-end">Total Amount</th>
                    <th class="text-center">Records</th>
                    <th class="text-center">Not Used</th>
                    <th>Recon Code</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="u in uploads" :key="u.id">
                    <td>{{ u.dateCreated }}</td>
                    <td>{{ u.createdBy }}</td>
                    <td>
                      <span :class="u.transactionType === 'MPESA' ? 'badge bg-success' : 'badge bg-primary'">
                        {{ u.transactionType }}
                      </span>
                    </td>
                    <td class="text-end">KES {{ formatPrice(u.totalAmount || 0) }}</td>
                    <td class="text-center">{{ u.totalRecords }}</td>
                    <td class="text-center">
                      <span :class="parseInt(u.missingTransactions) > 0 ? 'text-danger fw-bold' : 'text-success'">
                        {{ u.missingTransactions || 0 }}
                      </span>
                    </td>
                    <td><code class="small">{{ u.reconCode }}</code></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-center py-4 text-muted">No uploads found</div>
            </div>
          </div>

          <!-- Detail Records -->
          <div class="card">
            <div class="card-header bg-white border-bottom">
              <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div class="d-flex align-items-center gap-2">
                  <h4 class="card-title mb-0">Transaction Details</h4>
                  <div class="btn-group btn-group-sm">
                    <button class="btn" :class="detailFilter === 'all' ? 'btn-primary' : 'btn-outline-secondary'" @click="setDetailFilter('all')">All</button>
                    <button class="btn" :class="detailFilter === 'receipted' ? 'btn-success' : 'btn-outline-secondary'" @click="setDetailFilter('receipted')">Receipted</button>
                    <button class="btn" :class="detailFilter === 'unallocated' ? 'btn-warning' : 'btn-outline-secondary'" @click="setDetailFilter('unallocated')">Unallocated</button>
                    <button class="btn" :class="detailFilter === 'missing' ? 'btn-danger' : 'btn-outline-secondary'" @click="setDetailFilter('missing')">Not Used</button>
                    <button class="btn" :class="detailFilter === 'big' ? 'btn-dark' : 'btn-outline-secondary'" @click="setDetailFilter('big')">Big Amounts</button>
                  </div>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <span class="text-muted small" v-if="detailSummary.count > 0">
                    {{ numberFormat(detailSummary.count) }} records · KES {{ formatPrice(detailSummary.totalAmount) }}
                  </span>
                  <div class="position-relative" style="width: 250px">
                    <input v-model="detailSearch" type="text" class="form-control form-control-sm"
                           placeholder="Search code, invoice, name...">
                    <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                  </div>

                  <div class="dropdown" v-if="getRight('DOWNLOAD RECON HISTORY')">
                    <button class="btn btn-primary btn-sm dropdown-toggle" type="button"
                            data-bs-toggle="dropdown" :disabled="detailRecords.length === 0">
                      <i class="bx bxs-download me-1"></i> Export
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportToPDF"><i class="bx bxs-file-pdf me-2 text-danger"></i>PDF Report</a></li>
                      <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportAuditToExcel"><i class="bx bxs-file me-2 text-success"></i>Excel</a></li>
                      <li><a class="dropdown-item" href="javascript:void(0);" @click.prevent="exportAuditToCSV"><i class="bx bxs-file me-2 text-primary"></i>CSV</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body p-0">
              <div v-if="loadingDetails" class="text-center p-5">
                <div class="spinner-border text-info mb-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <h4>Loading Data</h4>
                <p>We are fetching the data for you. Please wait...</p>
              </div>

              <div class="table-responsive" v-else-if="detailRecords.length > 0">
                <table class="table table-hover mb-0">
                  <thead class="table-dark">
                  <tr>
                    <th class="text-nowrap">Date</th>
                    <th class="text-nowrap">Transaction Code</th>
                    <th class="text-nowrap text-end">Amount</th>
                    <th class="text-nowrap">Status</th>
                    <th class="text-nowrap" style="min-width:200px">Invoice/Ref</th>
                    <th class="text-nowrap">Bill No</th>
                    <th class="text-nowrap">Income Type</th>
                    <th class="text-nowrap">Receipted By</th>
                    <th class="text-nowrap">Payer</th>
                    <th class="text-nowrap">Sub-County</th>
                    <th class="text-nowrap">Department</th>
                    <th class="text-nowrap">Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="r in detailRecords" :key="r.bsId" :class="getRowClass(r)">
                    <td class="text-nowrap">{{ formatDate(r.bsDateCreated) }}</td>
                    <td class="text-nowrap"><code class="text-primary">{{ r.bsTransactionCode }}</code></td>
                    <td class="text-nowrap text-end fw-semibold">
                      KES {{ formatPrice(r.moneyIn) }}
                      <i v-if="parseFloat(r.moneyIn) >= threshold" class="bx bx-error text-danger ms-1" title="Big amount"></i>
                    </td>
                    <td>
                      <span v-if="getStatus(r) === 'Receipted'" class="badge bg-success text-uppercase">Receipted</span>
                      <span v-else-if="getStatus(r) === 'Unallocated'" class="badge bg-warning text-dark text-uppercase">Unallocated</span>
                      <span v-else class="badge bg-danger text-uppercase">Not Used</span>
                    </td>
                    <td style="min-width:200px">
                      <div v-if="r.account_ref">
                        <template v-for="(ref, idx) in splitRefs(r.account_ref)" :key="idx">
                          <a href="javascript:void(0)"
                             @click="getBill(ref.trim())"
                             class="text-decoration-none fw-semibold"
                             data-bs-toggle="modal"
                             data-bs-target="#billDetailModal">
                            {{ ref.trim() }}
                          </a>
                          <span v-if="idx < splitRefs(r.account_ref).length - 1" class="text-muted">, </span>
                        </template>
                      </div>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td class="text-nowrap">
                      <a v-if="r.billNo"
                         href="javascript:void(0)"
                         @click="getBill(r.billNo)"
                         class="text-decoration-none fw-semibold"
                         data-bs-toggle="modal"
                         data-bs-target="#billDetailModal">
                        {{ r.billNo }}
                      </a>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td>
                      <div v-if="r.incomeTypeDescription">
                        <strong>{{ r.incomeTypeDescription }}</strong>
                        <small class="text-muted d-block" v-if="r.feeDescription">{{ r.feeDescription }}</small>
                      </div>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td class="text-nowrap">
                      <div v-if="r.receiptedBy">
                        <span>{{ r.receiptedBy }}</span>
                        <br><small class="text-muted">{{ r.receiptedByIdNo }}</small>
                      </div>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td class="text-nowrap">
                      <div v-if="r.payerNames">
                        <span>{{ r.payerNames }}</span>
                        <br v-if="r.customerPhoneNumber"><small class="text-muted">{{ r.customerPhoneNumber }}</small>
                      </div>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td class="text-nowrap">{{ r.subCountyName || '-' }}</td>
                    <td class="text-nowrap">{{ r.department || '-' }}</td>
                    <td class="text-nowrap">
                      <button v-if="r.billNo"
                              @click="getBill(r.billNo)"
                              class="btn btn-primary btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#billDetailModal">
                        View
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div v-else class="text-center p-5">
                <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                <h4>No Results To Show</h4>
                <p>Sorry, we could not find any results that match your search or filter criteria.</p>
              </div>
            </div>

            <!-- Pagination -->
            <div class="card-footer bg-white" v-if="detailTotalPages > 0">
              <nav class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="me-3">Rows Per Page</span>
                  <select class="form-select w-auto" v-model="detailPageSize">
                    <option value="25">25 Rows</option>
                    <option value="50">50 Rows</option>
                    <option value="100">100 Rows</option>
                    <option value="200">200 Rows</option>
                    <option value="500">500 Rows</option>
                  </select>
                </div>
                <ul class="pagination mb-0">
                  <li class="page-item" :class="{ disabled: detailCurrentPage === 1 }">
                    <button class="page-link" @click="detailPrevPage" :disabled="detailCurrentPage === 1">Previous</button>
                  </li>
                  <li v-for="page in pagination(detailCurrentPage, detailTotalPages, 3)"
                      :key="page" class="page-item" :class="{ active: detailCurrentPage === page }">
                    <span v-if="page === '...'" class="page-link">{{ page }}</span>
                    <button v-else class="page-link" @click="detailGoToPage(page)">{{ page }}</button>
                  </li>
                  <li class="page-item" :class="{ disabled: detailCurrentPage === detailTotalPages }">
                    <button class="page-link" @click="detailNextPage" :disabled="detailCurrentPage === detailTotalPages">Next</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <BillDetailModal
          :billDetail="billDetail"
          :billInfo="billInfo"
          :billNo="billNo"
          @print-bill="printBill"
          @open-waiver="openWaiver"
          @description-updated="handleDescriptionUpdate"
          @customer-updated="handleCustomerUpdate"
      />

      <div v-if="alert.success || alert.failed || alert.info" class="toast-container position-fixed top-0 end-0 p-3">
        <div class="toast show" role="alert">
          <div class="toast-header" :class="{
              'bg-success text-white': alert.success,
              'bg-danger text-white': alert.failed,
              'bg-info text-white': alert.info
            }">
            <strong class="me-auto">Notification</strong>
            <button type="button" class="btn-close" @click="clearAlerts"></button>
          </div>
          <div class="toast-body">{{ message }}</div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© County Revenue System</div>
            <div class="col-sm-6"><div class="text-sm-end">Powered by Best Birdy Billing System</div></div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import BillDetailModal from "@/components/invoices/modals/BillDetailModal.vue";
import { biller, execute, getRight } from "@/api";
import router from "@/router";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
  name: "ReconAudit",
  components: { NavigationBar, BillDetailModal },
  data() {
    return {
      // Filters
      sourceFilter: 'ALL',
      dateFrom: '',
      dateTo: '',
      threshold: 50000,

      // Summary
      monthlySummary: [],
      totals: {},
      bigAmounts: {},
      loadingSummary: false,
      showMonthly: true,

      // Uploads
      uploads: [],
      loadingUploads: false,
      showUploads: false,

      // Details
      detailRecords: [],
      detailSummary: { count: 0, totalAmount: 0 },
      detailFilter: 'all',
      detailSearch: '',
      detailCurrentPage: 1,
      detailTotalPages: 0,
      detailPageSize: 25,
      loadingDetails: false,

      // Bill Detail Modal
      billDetail: {},
      billInfo: [],
      billNo: '',

      // Alerts
      alert: { success: false, info: false, failed: false },
      message: '',
    };
  },
  mounted() {
    this.loadAll();
    this.menuAccess();
  },
  watch: {
    detailPageSize() {
      this.detailCurrentPage = 1;
      this.loadDetails();
    },
    detailSearch() {
      clearTimeout(this._searchTimeout);
      this._searchTimeout = setTimeout(() => {
        this.detailCurrentPage = 1;
        this.loadDetails();
      }, 500);
    }
  },
  methods: {
    getRight,

    gotTo(route) { router.push(route); },

    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, msg) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = msg;
      setTimeout(() => { this.clearAlerts(); }, 5000);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Recon Audit");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch(e => { console.error("Menu access error:", e.message); });
    },

    // ==================== BILL DETAIL (same as BillsRaised) ====================

    async getBill(billNo) {
      try {
        if (!billNo) return;
        this.billNo = billNo;
        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);
        const res = await execute(data, biller);
        if (res.data.success) {
          this.billInfo = res.data.data.billInfo;
          this.billDetail = res.data.data.billDetails;
        } else {
          this.message = res.data.message;
        }
      } catch (e) { this.message = e.message; }
    },

    printBill() {
      localStorage['params'] = JSON.stringify({ billNo: this.billDetail.billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    openWaiver(item, type) {
      this.showAlert('info', 'Please use the Bills Raised page for waiver requests');
    },

    handleDescriptionUpdate(data) { this.billDetail.description = data.description; },

    handleCustomerUpdate(data) {
      const idx = this.billInfo.findIndex(item => item.id === data.id);
      if (idx !== -1) this.billInfo[idx].customer = data.customer;
    },

    extractBillNo(accountRef) {
      if (!accountRef) return '';
      return accountRef.split(',')[0].trim();
    },

    splitRefs(accountRef) {
      if (!accountRef) return [];
      return accountRef.split(',').map(r => r.trim()).filter(r => r.length > 0);
    },

    // ==================== STATUS HELPERS ====================

    getStatus(r) {
      if (r.txId && ((r.account_ref && r.account_ref.includes('BLL')) || (r.billNo && r.billNo !== ''))) return 'Receipted';
      if (r.txId) return 'Unallocated';
      return 'Not Used';
    },

    getRowClass(r) {
      const status = this.getStatus(r);
      let cls = {};
      if (status === 'Receipted') cls['table-success-light'] = true;
      else if (status === 'Unallocated') cls['table-warning-light'] = true;
      else cls['table-danger-light'] = true;
      if (parseFloat(r.moneyIn) >= this.threshold) cls['big-amount-row'] = true;
      return cls;
    },

    // ==================== DATA LOADING ====================

    loadAll() {
      this.loadSummary();
      this.loadUploadHistory();
      this.loadDetails();
    },

    async loadSummary() {
      this.loadingSummary = true;
      try {
        const data = new FormData();
        data.append("function", "getReconAuditSummary");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("threshold", this.threshold);
        data.append("sourceFilter", this.sourceFilter);
        const res = await execute(data, biller);
        this.loadingSummary = false;
        if (res.data.success) {
          this.monthlySummary = res.data.data.monthlySummary || [];
          this.totals = res.data.data.totals || {};
          this.bigAmounts = res.data.data.bigAmounts || {};
        }
      } catch (e) { this.loadingSummary = false; console.error("Summary error:", e); }
    },

    async loadUploadHistory() {
      this.loadingUploads = true;
      try {
        const data = new FormData();
        data.append("function", "getReconUploadHistory");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("sourceFilter", this.sourceFilter);
        const res = await execute(data, biller);
        this.loadingUploads = false;
        if (res.data.success) { this.uploads = res.data.data.uploads || []; }
      } catch (e) { this.loadingUploads = false; console.error("Upload history error:", e); }
    },

    async loadDetails() {
      this.loadingDetails = true;
      try {
        const data = new FormData();
        data.append("function", "getReconAuditUsedDetails");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.detailCurrentPage);
        data.append("rows_per_page", this.detailPageSize);
        data.append("search", this.detailSearch);
        data.append("filterType", this.detailFilter);
        data.append("threshold", this.threshold);
        data.append("sourceFilter", this.sourceFilter);
        const res = await execute(data, biller);
        this.loadingDetails = false;
        if (res.data.success) {
          this.detailRecords = res.data.data.records || [];
          this.detailSummary = res.data.data.summary || { count: 0, totalAmount: 0 };
          this.detailTotalPages = Math.ceil(this.detailSummary.count / this.detailPageSize);
        }
      } catch (e) { this.loadingDetails = false; console.error("Details error:", e); }
    },

    setDetailFilter(filter) {
      this.detailFilter = filter;
      this.detailCurrentPage = 1;
      this.loadDetails();
    },

    drillIntoMonth(month) {
      const [year, m] = month.split('-');
      this.dateFrom = `${year}-${m}-01`;
      const lastDay = new Date(year, parseInt(m), 0).getDate();
      this.dateTo = `${year}-${m}-${String(lastDay).padStart(2, '0')}`;
      this.loadAll();
    },

    // ==================== FORMATTING ====================

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    formatPrice(value) {
      let num = parseFloat(value) || 0;
      return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    formatMonth(ym) {
      if (!ym) return '';
      const [year, month] = ym.split('-');
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return `${months[parseInt(month) - 1]} ${year}`;
    },

    formatDate(dt) { return dt ? dt.substring(0, 16) : '-'; },

    truncate(str, len) {
      if (!str) return '';
      return str.length > len ? str.substring(0, len) + '...' : str;
    },

    getMonthReceiptedPct(row) {
      const total = parseFloat(row.totalUploaded) || 0;
      if (total === 0) return 0;
      return Math.round((parseFloat(row.totalReceipted || 0) / total) * 100);
    },

    // ==================== PAGINATION ====================

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);
      if (start < 1) { start = 1; end = start + maxVisibleButtons - 1; if (end > totalPages) end = totalPages; }
      if (end > totalPages) { end = totalPages; start = end - maxVisibleButtons + 1; if (start < 1) start = 1; }
      for (let i = start; i <= end; i++) pages.push(i);
      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");
      return pages;
    },

    detailPrevPage() { if (this.detailCurrentPage > 1) { this.detailCurrentPage--; this.loadDetails(); } },
    detailNextPage() { if (this.detailCurrentPage < this.detailTotalPages) { this.detailCurrentPage++; this.loadDetails(); } },
    detailGoToPage(page) {
      if (page > 0 && page <= this.detailTotalPages && page !== this.detailCurrentPage) {
        this.detailCurrentPage = page; this.loadDetails();
      }
    },

    // ==================== EXPORT ====================

    // ---------- UPLOAD HISTORY ----------

    exportUploadsToPDF() {
      if (this.uploads.length === 0) { alert("No data to export"); return; }
      try {
        const doc = new jsPDF('landscape', 'mm', 'a4');
        doc.setFontSize(18); doc.setFont(undefined, 'bold');
        doc.text("Upload History Report", 14, 15);
        doc.setFontSize(10); doc.setFont(undefined, 'normal');
        doc.text(`Source: ${this.sourceFilter} | Generated: ${new Date().toLocaleString()}`, 14, 23);

        autoTable(doc, {
          head: [["Date", "Uploaded By", "Type", "Total Amount (KES)", "Records", "Not Used", "Recon Code"]],
          body: this.uploads.map(u => [u.dateCreated, u.createdBy, u.transactionType, this.formatPrice(u.totalAmount || 0), u.totalRecords, u.missingTransactions || '0', u.reconCode]),
          startY: 28,
          styles: { fontSize: 8, cellPadding: 2 },
          headStyles: { fillColor: [52, 58, 64], textColor: 255, fontStyle: 'bold' },
          alternateRowStyles: { fillColor: [248, 249, 250] },
          columnStyles: { 3: { halign: 'right' }, 4: { halign: 'center' }, 5: { halign: 'center' } }
        });
        doc.save(`Upload_History_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.pdf`);
      } catch (error) { console.error(error); alert("Failed: " + error.message); }
    },

    exportUploadsToCSV() {
      if (this.uploads.length === 0) { alert("No data to export"); return; }
      let csv = 'Date,Uploaded By,Type,Total Amount,Records,Not Used,Recon Code\r\n';
      this.uploads.forEach(u => {
        csv += [u.dateCreated, `"${u.createdBy}"`, u.transactionType, u.totalAmount || 0, u.totalRecords, u.missingTransactions || 0, u.reconCode].join(',') + '\r\n';
      });
      this.downloadCSV(csv, `Upload_History_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.csv`);
    },

    // ---------- FULL REPORT (ALL SECTIONS) ----------

    exportFullReportPDF() {
      try {
        const doc = new jsPDF('landscape', 'mm', 'a4');
        const sourceLabel = this.sourceFilter === 'ALL' ? 'All Sources' : this.sourceFilter === 'BANK' ? 'Bank (KCB)' : 'MPESA';
        const dateLabel = (this.dateFrom && this.dateTo) ? `${this.dateFrom} to ${this.dateTo}` : 'All Dates';

        // PAGE 1: Summary + Monthly
        doc.setFontSize(20); doc.setFont(undefined, 'bold');
        doc.text("Reconciliation Audit - Full Report", 14, 15);
        doc.setFontSize(10); doc.setFont(undefined, 'normal');
        doc.text(`Source: ${sourceLabel} | Date Range: ${dateLabel} | Generated: ${new Date().toLocaleString()}`, 14, 23);

        // Summary box
        doc.setFillColor(245, 245, 245);
        doc.roundedRect(14, 28, 268, 18, 2, 2, 'F');
        doc.setFontSize(9); doc.setFont(undefined, 'bold');
        doc.setTextColor(0, 0, 0); doc.text("Total Uploaded", 20, 35); doc.setFontSize(10); doc.text(`KES ${this.formatPrice(this.totals.totalUploaded || 0)}`, 20, 41);
        doc.setFontSize(9); doc.setTextColor(34, 139, 34); doc.text("Receipted", 90, 35); doc.setFontSize(10); doc.text(`KES ${this.formatPrice(this.totals.totalReceipted || 0)}`, 90, 41);
        doc.setFontSize(9); doc.setTextColor(200, 150, 0); doc.text("Unallocated", 160, 35); doc.setFontSize(10); doc.text(`KES ${this.formatPrice(this.totals.totalUnallocated || 0)}`, 160, 41);
        doc.setFontSize(9); doc.setTextColor(220, 53, 69); doc.text("Not Used", 230, 35); doc.setFontSize(10); doc.text(`KES ${this.formatPrice(this.totals.totalMissing || 0)}`, 230, 41);
        doc.setTextColor(0, 0, 0);

        if (this.monthlySummary.length > 0) {
          doc.setFontSize(12); doc.setFont(undefined, 'bold'); doc.text("Monthly Breakdown", 14, 52);
          autoTable(doc, {
            head: [["Month", "Total Uploaded", "Receipted", "Unallocated", "Not Used", "R", "U", "NU", "%"]],
            body: this.monthlySummary.map(r => [this.formatMonth(r.month), this.formatPrice(r.totalUploaded), this.formatPrice(r.totalReceipted), this.formatPrice(r.totalUnallocated), this.formatPrice(r.totalMissing), r.receiptedCount, r.unallocatedCount, r.missingCount, this.getMonthReceiptedPct(r) + '%']),
            startY: 55, styles: { fontSize: 7, cellPadding: 1.5 },
            headStyles: { fillColor: [52, 58, 64], textColor: 255, fontStyle: 'bold', fontSize: 7 },
            alternateRowStyles: { fillColor: [248, 249, 250] },
            columnStyles: { 1: { halign: 'right' }, 2: { halign: 'right', textColor: [34, 139, 34] }, 3: { halign: 'right', textColor: [200, 150, 0] }, 4: { halign: 'right', textColor: [220, 53, 69] }, 5: { halign: 'center' }, 6: { halign: 'center' }, 7: { halign: 'center' }, 8: { halign: 'center' } }
          });
        }

        // PAGE 2: Upload History
        if (this.uploads.length > 0) {
          doc.addPage();
          doc.setFontSize(14); doc.setFont(undefined, 'bold'); doc.setTextColor(0, 0, 0);
          doc.text("Upload History", 14, 15);
          autoTable(doc, {
            head: [["Date", "Uploaded By", "Type", "Total Amount (KES)", "Records", "Not Used", "Recon Code"]],
            body: this.uploads.map(u => [u.dateCreated, u.createdBy, u.transactionType, this.formatPrice(u.totalAmount || 0), u.totalRecords, u.missingTransactions || '0', u.reconCode]),
            startY: 20, styles: { fontSize: 7, cellPadding: 1.5 },
            headStyles: { fillColor: [52, 58, 64], textColor: 255, fontStyle: 'bold', fontSize: 7 },
            alternateRowStyles: { fillColor: [248, 249, 250] }
          });
        }

        // PAGE 3: Transaction Details
        if (this.detailRecords.length > 0) {
          doc.addPage();
          doc.setFontSize(14); doc.setFont(undefined, 'bold'); doc.setTextColor(0, 0, 0);
          doc.text(`Transaction Details (${this.detailFilter.toUpperCase()})`, 14, 15);
          doc.setFontSize(9); doc.setFont(undefined, 'normal');
          doc.text(`${this.numberFormat(this.detailSummary.count)} records | KES ${this.formatPrice(this.detailSummary.totalAmount)}`, 14, 21);

          autoTable(doc, {
            head: [["Date", "Code", "Amount", "Status", "Invoice/Ref", "Bill No", "Income Type", "Receipted By", "Payer", "Sub-County"]],
            body: this.detailRecords.map(r => [this.formatDate(r.bsDateCreated), r.bsTransactionCode || '', this.formatPrice(r.moneyIn), this.getStatus(r), this.truncate(r.account_ref || '-', 25), r.billNo || '-', this.truncate(r.incomeTypeDescription || '-', 20), r.receiptedBy || '-', r.payerNames || '-', r.subCountyName || '-']),
            startY: 25, styles: { fontSize: 7, cellPadding: 1.5 },
            headStyles: { fillColor: [52, 58, 64], textColor: 255, fontStyle: 'bold', fontSize: 7 },
            alternateRowStyles: { fillColor: [248, 249, 250] },
            columnStyles: { 2: { halign: 'right' } },
            didParseCell: function(data) {
              if (data.section === 'body' && data.column.index === 3) {
                if (data.cell.text[0] === 'Receipted') { data.cell.styles.textColor = [34, 139, 34]; data.cell.styles.fontStyle = 'bold'; }
                else if (data.cell.text[0] === 'Unallocated') { data.cell.styles.textColor = [200, 150, 0]; data.cell.styles.fontStyle = 'bold'; }
                else if (data.cell.text[0] === 'Not Used') { data.cell.styles.textColor = [220, 53, 69]; data.cell.styles.fontStyle = 'bold'; }
              }
            }
          });
        }

        // Page numbers
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          doc.setFontSize(8); doc.setTextColor(150, 150, 150);
          doc.text(`Page ${i} of ${totalPages}`, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 8);
          doc.text('County Biller - Reconciliation Audit', 14, doc.internal.pageSize.height - 8);
        }

        doc.save(`Full_Audit_Report_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.pdf`);
      } catch (error) { console.error(error); alert("Failed: " + error.message); }
    },

    exportFullReportCSV() {
      let csv = 'RECONCILIATION AUDIT SUMMARY\r\n';
      csv += `Source,${this.sourceFilter}\r\nDate Range,${this.dateFrom || 'All'} to ${this.dateTo || 'All'}\r\n`;
      csv += `Total Uploaded,${this.totals.totalUploaded || 0}\r\nReceipted,${this.totals.totalReceipted || 0}\r\nUnallocated,${this.totals.totalUnallocated || 0}\r\nNot Used,${this.totals.totalMissing || 0}\r\n\r\n`;

      csv += 'MONTHLY BREAKDOWN\r\nMonth,Total Uploaded,Receipted,Unallocated,Not Used,Receipted Count,Unallocated Count,Not Used Count,Receipted %\r\n';
      this.monthlySummary.forEach(r => { csv += [this.formatMonth(r.month), r.totalUploaded, r.totalReceipted, r.totalUnallocated, r.totalMissing, r.receiptedCount, r.unallocatedCount, r.missingCount, this.getMonthReceiptedPct(r) + '%'].join(',') + '\r\n'; });
      csv += '\r\n';

      csv += 'UPLOAD HISTORY\r\nDate,Uploaded By,Type,Total Amount,Records,Not Used,Recon Code\r\n';
      this.uploads.forEach(u => { csv += [u.dateCreated, `"${u.createdBy}"`, u.transactionType, u.totalAmount || 0, u.totalRecords, u.missingTransactions || 0, u.reconCode].join(',') + '\r\n'; });
      csv += '\r\n';

      csv += 'TRANSACTION DETAILS\r\nDate,Transaction Code,Amount,Status,Invoice/Ref,Bill No,Income Type,Receipted By,Payer,Sub-County,Department\r\n';
      this.detailRecords.forEach(r => { csv += [r.bsDateCreated, r.bsTransactionCode, r.moneyIn, this.getStatus(r), `"${(r.account_ref || '').replace(/"/g, '""')}"`, r.billNo || '', `"${(r.incomeTypeDescription || '').replace(/"/g, '""')}"`, r.receiptedBy || '', r.payerNames || '', r.subCountyName || '', r.department || ''].join(',') + '\r\n'; });

      this.downloadCSV(csv, `Full_Audit_Report_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.csv`);
    },

    // CSV download helper
    downloadCSV(csv, filename) {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // ---------- MONTHLY BREAKDOWN ----------

    exportMonthlyToPDF() {
      if (this.monthlySummary.length === 0) { alert("No data to export"); return; }
      try {
        const doc = new jsPDF('landscape', 'mm', 'a4');
        const sourceLabel = this.sourceFilter === 'ALL' ? 'All Sources' : this.sourceFilter === 'BANK' ? 'Bank (KCB)' : 'MPESA';
        const dateLabel = (this.dateFrom && this.dateTo) ? `${this.dateFrom} to ${this.dateTo}` : 'All Dates';

        // Header
        doc.setFontSize(18);
        doc.setFont(undefined, 'bold');
        doc.text("Monthly Reconciliation Summary", 14, 15);

        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`Source: ${sourceLabel}`, 14, 23);
        doc.text(`Date Range: ${dateLabel}`, 14, 28);
        doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 33);

        // Summary totals
        doc.setFillColor(245, 245, 245);
        doc.roundedRect(14, 37, 268, 18, 2, 2, 'F');

        doc.setFontSize(9);
        doc.setFont(undefined, 'bold');
        doc.text("Total Uploaded", 20, 44);
        doc.setFontSize(10);
        doc.text(`KES ${this.formatPrice(this.totals.totalUploaded || 0)}`, 20, 50);

        doc.setFontSize(9);
        doc.setTextColor(34, 139, 34);
        doc.text("Receipted", 90, 44);
        doc.setFontSize(10);
        doc.text(`KES ${this.formatPrice(this.totals.totalReceipted || 0)}`, 90, 50);

        doc.setFontSize(9);
        doc.setTextColor(200, 150, 0);
        doc.text("Unallocated", 160, 44);
        doc.setFontSize(10);
        doc.text(`KES ${this.formatPrice(this.totals.totalUnallocated || 0)}`, 160, 50);

        doc.setFontSize(9);
        doc.setTextColor(220, 53, 69);
        doc.text("Not Used", 230, 44);
        doc.setFontSize(10);
        doc.text(`KES ${this.formatPrice(this.totals.totalMissing || 0)}`, 230, 50);

        doc.setTextColor(0, 0, 0);

        // Monthly table
        const columns = ["Month", "Total Uploaded (KES)", "Receipted (KES)", "Unallocated (KES)", "Not Used (KES)", "Receipted", "Unallocated", "Not Used", "Receipted %"];
        const rows = this.monthlySummary.map(row => [
          this.formatMonth(row.month),
          this.formatPrice(row.totalUploaded),
          this.formatPrice(row.totalReceipted),
          this.formatPrice(row.totalUnallocated),
          this.formatPrice(row.totalMissing),
          row.receiptedCount,
          row.unallocatedCount,
          row.missingCount,
          this.getMonthReceiptedPct(row) + '%'
        ]);

        autoTable(doc, {
          head: [columns],
          body: rows,
          startY: 58,
          styles: { fontSize: 8, cellPadding: 2 },
          headStyles: { fillColor: [52, 58, 64], textColor: 255, fontStyle: 'bold', fontSize: 8 },
          alternateRowStyles: { fillColor: [248, 249, 250] },
          columnStyles: {
            1: { halign: 'right' },
            2: { halign: 'right', textColor: [34, 139, 34] },
            3: { halign: 'right', textColor: [200, 150, 0] },
            4: { halign: 'right', textColor: [220, 53, 69] },
            5: { halign: 'center' },
            6: { halign: 'center' },
            7: { halign: 'center' },
            8: { halign: 'center' }
          }
        });

        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.text(`${this.monthlySummary.length} months | ${this.numberFormat(this.totals.totalRecords || 0)} total records`, 14, pageHeight - 10);

        doc.save(`Monthly_Summary_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.pdf`);
      } catch (error) {
        console.error("Monthly PDF export error:", error);
        alert("Failed to export Monthly PDF: " + error.message);
      }
    },

    exportMonthlyToCSV() {
      if (this.monthlySummary.length === 0) { alert("No data to export"); return; }
      const fields = ['Month','Total Uploaded','Receipted','Unallocated','Not Used','Receipted Count','Unallocated Count','Not Used Count','Receipted %'];
      let csv = fields.join(',') + '\r\n';
      this.monthlySummary.forEach(row => {
        csv += [
          this.formatMonth(row.month),
          row.totalUploaded,
          row.totalReceipted,
          row.totalUnallocated,
          row.totalMissing,
          row.receiptedCount,
          row.unallocatedCount,
          row.missingCount,
          this.getMonthReceiptedPct(row) + '%'
        ].join(',') + '\r\n';
      });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Monthly_Summary_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.csv`;
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    exportToPDF() {
      if (this.detailRecords.length === 0) { alert("No data to export"); return; }

      try {
        const doc = new jsPDF('landscape', 'mm', 'a4');

        const sourceLabel = this.sourceFilter === 'ALL' ? 'All Sources' : this.sourceFilter === 'BANK' ? 'Bank (KCB)' : 'MPESA';
        const dateLabel = (this.dateFrom && this.dateTo) ? `${this.dateFrom} to ${this.dateTo}` : 'All Dates';

        // Header
        doc.setFontSize(18);
        doc.setFont(undefined, 'bold');
        doc.text("Reconciliation Audit Report", 14, 15);

        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`Source: ${sourceLabel}`, 14, 23);
        doc.text(`Date Range: ${dateLabel}`, 14, 28);
        doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 33);
        doc.text(`Filter: ${this.detailFilter.toUpperCase()}`, 14, 38);

        // Summary box
        doc.setFillColor(245, 245, 245);
        doc.roundedRect(14, 42, 268, 22, 2, 2, 'F');

        doc.setFontSize(9);
        doc.setFont(undefined, 'bold');

        doc.setTextColor(0, 0, 0);
        doc.text("Total Uploaded", 20, 49);
        doc.setFontSize(11);
        doc.text(`KES ${this.formatPrice(this.totals.totalUploaded || 0)}`, 20, 56);

        doc.setFontSize(9);
        doc.setTextColor(34, 139, 34);
        doc.text("Receipted", 90, 49);
        doc.setFontSize(11);
        doc.text(`KES ${this.formatPrice(this.totals.totalReceipted || 0)}`, 90, 56);

        doc.setFontSize(9);
        doc.setTextColor(200, 150, 0);
        doc.text("Unallocated", 160, 49);
        doc.setFontSize(11);
        doc.text(`KES ${this.formatPrice(this.totals.totalUnallocated || 0)}`, 160, 56);

        doc.setFontSize(9);
        doc.setTextColor(220, 53, 69);
        doc.text("Not Used", 230, 49);
        doc.setFontSize(11);
        doc.text(`KES ${this.formatPrice(this.totals.totalMissing || 0)}`, 230, 56);

        doc.setTextColor(0, 0, 0);

        // Table
        const tableColumn = ["Date", "Transaction Code", "Amount (KES)", "Status", "Invoice/Ref", "Bill No", "Income Type", "Receipted By", "Payer", "Sub-County"];
        const tableRows = [];

        this.detailRecords.forEach(r => {
          tableRows.push([
            this.formatDate(r.bsDateCreated),
            r.bsTransactionCode || '',
            this.formatPrice(r.moneyIn),
            this.getStatus(r),
            this.truncate(r.account_ref || '-', 25),
            r.billNo || '-',
            this.truncate(r.incomeTypeDescription || '-', 20),
            r.receiptedBy || '-',
            r.payerNames || '-',
            r.subCountyName || '-'
          ]);
        });

        autoTable(doc, {
          head: [tableColumn],
          body: tableRows,
          startY: 68,
          styles: { fontSize: 7, cellPadding: 1.5 },
          headStyles: {
            fillColor: [52, 58, 64],
            textColor: 255,
            fontStyle: 'bold',
            fontSize: 7
          },
          bodyStyles: { fontSize: 7 },
          alternateRowStyles: { fillColor: [248, 249, 250] },
          columnStyles: {
            0: { cellWidth: 28 },
            1: { cellWidth: 28 },
            2: { cellWidth: 25, halign: 'right' },
            3: { cellWidth: 20 },
            4: { cellWidth: 35 },
            5: { cellWidth: 28 },
            6: { cellWidth: 30 },
            7: { cellWidth: 25 },
            8: { cellWidth: 25 },
            9: { cellWidth: 25 }
          },
          didParseCell: function(data) {
            if (data.section === 'body' && data.column.index === 3) {
              if (data.cell.text[0] === 'Receipted') {
                data.cell.styles.textColor = [34, 139, 34];
                data.cell.styles.fontStyle = 'bold';
              } else if (data.cell.text[0] === 'Unallocated') {
                data.cell.styles.textColor = [200, 150, 0];
                data.cell.styles.fontStyle = 'bold';
              } else if (data.cell.text[0] === 'Not Used') {
                data.cell.styles.textColor = [220, 53, 69];
                data.cell.styles.fontStyle = 'bold';
              }
            }
          }
        });

        // Footer on last page
        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.text(`Total Records: ${this.numberFormat(this.detailSummary.count)} | Total Amount: KES ${this.formatPrice(this.detailSummary.totalAmount)} | Page shows ${this.detailRecords.length} records`, 14, pageHeight - 10);

        doc.save(`Recon_Audit_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.pdf`);
      } catch (error) {
        console.error("PDF export error:", error);
        alert("Failed to export PDF. Make sure jsPDF is loaded.");
      }
    },

    exportAuditToExcel() {
      if (this.detailRecords.length === 0) { alert("No data to export"); return; }
      try {
        const workbook = XLSX.utils.book_new();
        const formatted = this.detailRecords.map(r => ({
          'Date': r.bsDateCreated,
          'Transaction Code': r.bsTransactionCode,
          'Amount': parseFloat(r.moneyIn) || 0,
          'Status': this.getStatus(r),
          'Invoice/Ref': r.account_ref || '',
          'Bill No': r.billNo || '',
          'Income Type': r.incomeTypeDescription || '',
          'Fee Description': r.feeDescription || '',
          'Receipted By': r.receiptedBy || '',
          'Receipted ID': r.receiptedByIdNo || '',
          'Payer': r.payerNames || '',
          'Customer Phone': r.customerPhoneNumber || '',
          'Sub-County': r.subCountyName || '',
          'Department': r.department || '',
        }));
        const ws = XLSX.utils.json_to_sheet(formatted);
        ws['!cols'] = [{wch:18},{wch:16},{wch:14},{wch:12},{wch:30},{wch:18},{wch:25},{wch:25},{wch:20},{wch:15},{wch:20},{wch:15},{wch:18},{wch:18}];
        XLSX.utils.book_append_sheet(workbook, ws, 'Audit');
        XLSX.writeFile(workbook, `Recon_Audit_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.xlsx`);
      } catch (e) { console.error("Export error:", e); alert("Export failed"); }
    },

    exportAuditToCSV() {
      if (this.detailRecords.length === 0) { alert("No data to export"); return; }
      const fields = ['Date','Transaction Code','Amount','Status','Invoice/Ref','Bill No','Income Type','Receipted By','Receipted ID','Payer','Sub-County','Department'];
      let csv = fields.join(',') + '\r\n';
      this.detailRecords.forEach(r => {
        const row = [
          r.bsDateCreated, r.bsTransactionCode, r.moneyIn, this.getStatus(r),
          `"${(r.account_ref || '').replace(/"/g, '""')}"`, r.billNo || '',
          `"${(r.incomeTypeDescription || '').replace(/"/g, '""')}"`,
          r.receiptedBy || '', r.receiptedByIdNo || '', r.payerNames || '',
          r.subCountyName || '', r.department || ''
        ];
        csv += row.join(',') + '\r\n';
      });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Recon_Audit_${this.sourceFilter}_${this.dateFrom || 'all'}_to_${this.dateTo || 'all'}.csv`;
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
.table th { white-space: nowrap; vertical-align: middle; }
.table td { vertical-align: middle; }
.form-label { font-weight: 600; font-size: 0.875rem; }
.badge { font-size: 0.75rem; }
.btn-sm { padding: 0.25rem 0.5rem; font-size: 0.75rem; }
.card-header { padding: 1rem; }
.toast-container { z-index: 9999; }
.text-decoration-none:hover { text-decoration: underline !important; }
.table-success-light { background-color: rgba(16, 185, 129, 0.04); }
.table-warning-light { background-color: rgba(245, 158, 11, 0.04); }
.table-danger-light { background-color: rgba(239, 68, 68, 0.04); }
.big-amount-row { border-left: 3px solid #ef4444; }
.progress { background-color: #e9ecef; border-radius: 999px; }
</style>